var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.isServiceExist
    ? _c("div", [
        _c(
          "div",
          [
            _c(
              "v-row",
              {
                staticClass: "mb-6"
              },
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12"
                    }
                  },
                  [
                    _c(
                      "gg-card-title",
                      {
                        staticClass: "pt-0"
                      },
                      [
                        _c("hosting-breadcrumbs", {
                          attrs: {
                            "managed-item-name": _vm.managedItemName,
                            hostingid: _vm.hostingid
                          }
                        }),
                        _vm.initialRoute
                          ? _c("div", [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.label) +
                                    " " +
                                    _vm._s(_vm.managedItemName) +
                                    " "
                                )
                              ])
                            ])
                          : _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    typeof _vm.$route.meta.pageSubtitle ===
                                      "function"
                                      ? _vm.$route.meta.pageSubtitle()
                                      : _vm.$route.meta.pageSubtitle
                                  ) +
                                  " "
                              )
                            ])
                      ],
                      1
                    ),
                    _vm.loading && _vm.showAdvancedLink
                      ? [
                          _c("gg-loading", {
                            attrs: {
                              loading: _vm.loading,
                              height: "10",
                              "max-width": "200",
                              type: "image"
                            }
                          })
                        ]
                      : [
                          _vm.showAdvancedLink
                            ? _c(
                                "div",
                                {
                                  staticClass: "body-2 pt-2"
                                },
                                [
                                  _vm._v(" Advanced users: "),
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.cpanelLoginUrl,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v("cPanel"),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mb-1 ml-1",
                                            attrs: {
                                              small: ""
                                            }
                                          },
                                          [_vm._v("mdi-open-in-new")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  this.isReseller
                                    ? [
                                        _c("span", [_vm._v(" / ")]),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.whmLoginUrl,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v("WHM"),
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mb-1 ml-1",
                                                attrs: {
                                                  small: ""
                                                }
                                              },
                                              [_vm._v("mdi-open-in-new")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                  ],
                  2
                ),
                _vm.hideSelect && !_vm.isResellerSubAccount
                  ? _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [_c("hosting-switch")],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(_vm.service_type, {
              tag: "component",
              attrs: {
                loading: _vm.loading
              }
            })
          ],
          1
        )
      ])
    : _c("preloader")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }